import { useEffect, useRef, useState } from 'react'
import {
  SActionBtn,
  SDrawerOrModal,
  SGeneralForms,
  SLowcodeList,
  SMessage,
  STableActions,
} from 'shj-components'
import { config } from './config'
import {
  getProductEnums,
  getunitPage,
  projectUpdateState,
  unitOperateAdd,
  updateUnit,
} from '@/services/product.ts'
import { apiData2Table, trimStr } from '@/utils/data.ts'
import { Input, message, Select, Switch } from 'antd'
import { isEmpty } from 'lodash-es'
export default function UnitManage() {
  const listRef = useRef()
  const formRef = useRef<any>()
  const [open, setOpen] = useState(false)
  const [record, setRecord] = useState({})
  const [btnLoading, setBtnLoading] = useState(false)
  const [UnitTypeEnum, setUnitTypeEnum] = useState([])
  const fetchList = values => {
    const { current, pageSize, ...rest } = values
    return new Promise((resolve, reject) => {
      getunitPage({
        params: { pageId: current, pageSize },
        data: rest.query,
      })
        .then(res => {
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }
  const onAdd = () => onEdit()
  const onEdit = (record = {}) => {
    setOpen(true)
    setRecord(record)
  }

  useEffect(() => {
    if (!isEmpty(record)) formRef.current?.onFormRef().setFieldsValue(record)
    return () => {
      formRef.current?.onFormRef().resetFields()
    }
  }, [record])

  //  表格事件: 删除
  // const onDel = id => {
  //   SMessage.confirm({
  //     onOk: () => {
  //       return deleteSpecialCode(id).then((res: any) => {
  //         message.success(res.message || '操作成功')
  //         listRef.current?.reload()
  //       })
  //     },
  //   })
  // }

  const onChangeStatus = (enabled: boolean, id: string) => {
    SMessage.confirm({
      title: `${enabled ? '打开' : '关闭'}开关，将${enabled ? '启用' : '禁用'}参数，是否继续？`,
      okText: '继续',
      content: null,
      onOk: () => {
        return projectUpdateState({ enabled, idList: [id] }).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onSubmit = () => {
    formRef.current
      ?.onFormRef()
      .validateFields()
      .then(values => {
        setBtnLoading(true)
        const apiUrl = values.id ? updateUnit : unitOperateAdd
        apiUrl({ data: { ...values } })
          .then((res: any) => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
            setOpen(false)
          })
          .finally(() => setBtnLoading(false))
      })
  }

  const getStatusOptions = async () => {
    const UnitTypeEnum: any = await getProductEnums('com.shj.saas.plus.product.enums.UnitTypeEnum')
    setUnitTypeEnum(UnitTypeEnum)
    return Promise.resolve({ UnitTypeEnum })
  }

  const extensions = {
    request: { fetchList, getStatusOptions },
    events: {
      onAdd,
    },
    status: {
      selectedDisabled: ({ selectedRowKeys }: any) => !selectedRowKeys.length,
      radioDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length !== 1,
    },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return <Switch checked={v} onClick={checked => onChangeStatus(checked, record.id)} />
      },
      optionCell(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
            {/* <SActionBtn danger onClick={() => onDel(record.id)}>
              {' '}
              删除{' '}
            </SActionBtn> */}
          </STableActions>
        )
      },
    },
  }

  return (
    <div>
      <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      <SDrawerOrModal
        title={(record.id ? '编辑' : '新增') + '单位'}
        mode="modal"
        open={open}
        loading={btnLoading}
        onCancel={() => setOpen(false)}
        onOk={onSubmit}
        width={500}
      >
        <SGeneralForms
          ref={formRef}
          layout={'vertical'}
          initialValues={{ enabled: true }}
          configs={[
            {
              formItem: [
                { label: 'id', name: 'id', hidden: true },
                {
                  name: 'code',
                  spanCol: 24,
                  label: '编码',
                  children: <Input disabled />,
                },
                {
                  name: 'name',
                  label: '单位名称',
                  required: true,
                  spanCol: 24,
                  rules: [{ required: true, message: '单位名称不能为空' }],
                  comConfig: {
                    onChange: e =>
                      formRef.current?.onFormRef()?.setFieldValue('name', trimStr(e.target.value)),
                  },
                },
                {
                  label: '单位类型',
                  name: 'type',
                  spanCol: 24,
                  required: true,
                  rules: [{ required: true, message: '单位类型不能为空' }],
                  children: (
                    <Select
                      allowClear
                      placeholder="请选择"
                      options={UnitTypeEnum}
                      fieldNames={{ label: 'description', value: 'key' }}
                    />
                  ),
                },
                {
                  name: 'alias1',
                  spanCol: 24,
                  label: '别名1',
                },
                {
                  name: 'alias2',
                  spanCol: 24,
                  label: '别名2',
                },
                {
                  name: 'alias3',
                  spanCol: 24,
                  label: '别名3',
                },
                {
                  label: '是否启用',
                  name: 'enabled',
                  type: 'switch',
                  spanCol: 24,
                  required: true,
                },
              ],
            },
          ]}
        />
      </SDrawerOrModal>
    </div>
  )
}
